import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { SignalUpdateInput } from '@terra/shared-contracts-signals';
import { terraProxyApiClient } from '../../clients/testerClient';

export const SIGNAL_DETAIL_QUERY_KEY = 'signal-detail';

type UpdateSignalParams = {
  signalId: string;
  update: SignalUpdateInput;
};

export const useUpdateSignal = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ signalId, update }: UpdateSignalParams) =>
      terraProxyApiClient.updateSignal(signalId, update),
    onSuccess: (_data, { signalId }) => {
      void queryClient.invalidateQueries({
        queryKey: [SIGNAL_DETAIL_QUERY_KEY, signalId],
      });
      void queryClient.invalidateQueries({
        queryKey: ['endpoint-signals-paginated'],
        exact: false,
      });
    },
  });

  const updateSignal = useCallback(
    async ({ signalId, update }: UpdateSignalParams) =>
      mutation.mutateAsync({ signalId, update }),
    [mutation],
  );

  return {
    updateSignal,
    isUpdating: mutation.isPending,
    error: mutation.error,
  };
};
